import React from 'react';

type BookingStatus = 'pending' | 'confirmed' | 'in-progress' | 'completed' | 'cancelled' | 'no-show';
type PaymentStatus = 'unpaid' | 'deposit-paid' | 'paid-full' | 'refunded';

const bookingStatusConfig: Record<BookingStatus, { label: string; className: string }> = {
  'pending': { label: 'Pending', className: 'bg-amber-500/15 text-amber-400 border-amber-500/30' },
  'confirmed': { label: 'Confirmed', className: 'bg-blue-500/15 text-blue-400 border-blue-500/30' },
  'in-progress': { label: 'In Progress', className: 'bg-violet-500/15 text-violet-400 border-violet-500/30' },
  'completed': { label: 'Completed', className: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30' },
  'cancelled': { label: 'Cancelled', className: 'bg-red-500/15 text-red-400 border-red-500/30' },
  'no-show': { label: 'No-Show', className: 'bg-zinc-500/15 text-zinc-400 border-zinc-500/30' },
};

const paymentStatusConfig: Record<PaymentStatus, { label: string; className: string }> = {
  'unpaid': { label: 'Unpaid', className: 'bg-red-500/15 text-red-400 border-red-500/30' },
  'deposit-paid': { label: 'Deposit Paid', className: 'bg-amber-500/15 text-amber-400 border-amber-500/30' },
  'paid-full': { label: 'Paid Full', className: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30' },
  'refunded': { label: 'Refunded', className: 'bg-zinc-500/15 text-zinc-400 border-zinc-500/30' },
};

interface StatusBadgeProps {
  type: 'booking' | 'payment';
  status: string;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ type, status, size = 'md' }: StatusBadgeProps) {
  const config = type === 'booking'
    ? bookingStatusConfig[status as BookingStatus]
    : paymentStatusConfig[status as PaymentStatus];

  if (!config) return null;

  return (
    <span
      className={`inline-flex items-center border rounded-full font-medium ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs'
      } ${config.className}`}
    >
      {config.label}
    </span>
  );
}